import { Alert, Button } from 'antd';
import { Smartphone } from 'lucide-react';
import { SecurityMethodCard } from '../../../components/SecurityMethodCard';
import { TurnOffWithPassword } from '../../../components/TurnOffWithPassword';

interface TotpStatusCardProps {
  enabled: boolean;
  error: string | null;
  submitting: boolean;
  onEnable: () => void;
  onDisable: (password: string) => Promise<boolean>;
}

/** The at-rest view of the authenticator app: on or off, with the one action available from here. */
export function TotpStatusCard({ enabled, error, submitting, onEnable, onDisable }: TotpStatusCardProps) {
  return (
    <SecurityMethodCard
      icon={Smartphone}
      title="Authenticator app"
      isEnabled={enabled}
      description={enabled ? 'A code from your authenticator app can finish signing in.' : 'Use a code from an app such as Google Authenticator or 1Password.'}
    >
      {!enabled && (
        <>
          {error && <Alert className="mt-5" type="error" title={error} showIcon />}
          <Button className="mt-5" type="primary" onClick={onEnable} loading={submitting}>
            Turn on
          </Button>
        </>
      )}
      {enabled && <TurnOffWithPassword error={error} submitting={submitting} onConfirm={onDisable} />}
    </SecurityMethodCard>
  );
}
